module.exports = __webpack_public_path__ + "zocdoc-large-blob-logo___2eP10.svg";